import apiClient from '@/services/axios'

export async function put(courseId, lessonInstanceId, payload) {
  var response = await apiClient.put('/courseInstances/' + courseId + "/" + lessonInstanceId, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to save Lesson.')
}
